module.exports = __webpack_public_path__ + "img/8.37c09d3e.jpg";